import { render, staticRenderFns } from "./BaseTitleTable.vue?vue&type=template&id=3252fe6c&"
import script from "./BaseTitleTable.vue?vue&type=script&lang=js&"
export * from "./BaseTitleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports